import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import ListItemText from "@material-ui/core/ListItemText";
import { contentClient } from "../../AxiosClient";

import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Chip from "@material-ui/core/Chip";
import FormHelperText from "@material-ui/core/FormHelperText";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import Input from "@material-ui/core/Input";

const styles = (theme) => ({
  formControl: {
    marginBottom: 10,
    minWidth: 250,
  },
  textField: {
    margin: theme.spacing(1),
  },
  labelInput: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
});
class GlobalCustomFieldAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customFields: [],
      selected: [],
    };
  }
  componentDidMount() {
    contentClient.get(`/global/customfield/`).then((res) => {
      this.setState({ customFields: res.data });
    });
  }
  handleChange = (event) => {
    this.setState({ selected: event.target.value });
  };
  render() {
    const { classes, t } = this.props;
    return (
      <Dialog
        open={this.props.GlobalCustomFieldAddOpen}
      >
        <DialogTitle>
          <Trans i18nKey="add_global_custom_fields" />
        </DialogTitle>
        <DialogContent
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            height: "100%",
          }}
        >
          <FormControl className={classes.formControl}>
            <Select
              multiple
              value={this.state.selected}
              onChange={this.handleChange}
              input={<Input />}
              renderValue={(selected) => {
                let valueString = "";
                selected.map((cf) => {
                  valueString = valueString + cf.name + ", ";
                });
                return valueString;
              }}
              // MenuProps={MenuProps}
            >
              {this.state.customFields.map((customField) => (
                <MenuItem key={customField} value={customField}>
                  <Checkbox
                    checked={this.state.selected.indexOf(customField) > -1}
                  />
                  <ListItemText primary={customField.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={this.props.close}
          >
            <Trans i18nKey="global_cancel" />
          </Button>
          <Button
            disabled={this.state.selected.length === 0}
            variant="contained"
            color="primary"
            onClick={() => {
              let cfs = this.state.selected;
              cfs.map((cf) => {
                cf.id = null;
              });
              this.props.addCustomFields(cfs);
            }}
          >
            <Trans i18nKey="save" />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withTranslation()(withStyles(styles)(GlobalCustomFieldAdd));
